const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';

export const telegramApi = {
  // Get all active Telegram sessions
  getSessions: async (token) => {
    const response = await fetch(`${BASE_URL}/telegram/sessions`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Get messages for a specific session
  getSessionMessages: async (sessionId, token, limit = 50) => {
    const response = await fetch(`${BASE_URL}/telegram/sessions/${sessionId}/messages?limit=${limit}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Send a reply to a Telegram user
  sendReply: async (chatId, message, token) => {
    const response = await fetch(`${BASE_URL}/telegram/reply`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ chatId, message })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Get bot status
  getStatus: async (token) => {
    const response = await fetch(`${BASE_URL}/telegram/status`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Resolve/archive a session
  resolveSession: async (sessionId, token) => {
    const response = await fetch(`${BASE_URL}/telegram/sessions/${sessionId}/resolve`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Delete a session
  deleteSession: async (sessionId, token) => {
    const response = await fetch(`${BASE_URL}/telegram/sessions/${sessionId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Fetch a Telegram file via backend proxy (returns a blob object URL)
  getFileUrl: async (fileId, token) => {
    const response = await fetch(
      `${BASE_URL}/telegram/file?fileId=${encodeURIComponent(fileId)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    return {
      success: true,
      data: { url: URL.createObjectURL(blob) },
    };
  },
};
